import React from 'react';
import PropTypes from 'prop-types';
import Entity from '../../Entity';
import Title from '../../Title';
import { paymentTitles } from './PaymentSubmit.constants';
import styles from './PaymentSubmit.module.scss';
import { paymentTypes } from '../../../constants';

const PaymentOptions = ({ companyName, sessionPayment, isReducedFeeTypeWaive, handleAddPayment }) => {
    const hasPaymentType = sessionPayment?.paymentType;

    if (hasPaymentType || isReducedFeeTypeWaive) {
        return null;
    }

    return (
        <div>
            <Title className='mtXL' title='Select Payment Type' type='h2' />
            <p>
                Select the payment type you wish to use to pay the application fee for {companyName}.
            </p>
            <div className={styles.list}>
                <Entity
                    testId='payment-option-ach'
                    title={paymentTitles.ACH}
                    subTitle="Select"
                    size="small"
                    onClick={() => handleAddPayment(paymentTypes.ACH_CHECKINGS)}
                />
                <Entity
                    testId='payment-option-credit-card'
                    title={paymentTitles.CREDIT_CARD}
                    subTitle="Select"
                    size="small"
                    onClick={() => handleAddPayment(paymentTypes.CREDIT)}
                />
                <Entity
                    testId='payment-option-offline'
                    title={paymentTitles.OFFLINE}
                    subTitle="Select"
                    size="small"
                    onClick={() => handleAddPayment(paymentTypes.OFFLINE)}
                />
            </div>
        </div>
    );
};

PaymentOptions.propTypes = {
    companyName: PropTypes.string.isRequired,
    sessionPayment: PropTypes.object.isRequired,
    handleAddPayment: PropTypes.func.isRequired,
    isReducedFeeTypeWaive: PropTypes.bool.isRequired,
};

export default PaymentOptions;